import { FC } from 'react';
import { ShareButton } from '@components/button';
import { CreatorProfile } from '@components/creatorProfile';
import HeartButton from '@components/heart/HeartButton';
import { useWindowSize } from '@shared/utils/hooks';
import { CookingTimeAndPeople } from '.';
import breakpoint from '../../../../shared/assets/breakpoint.json';
import { ButtonWrapper, Desceiption, DetailWrapper, Title, Wrapper } from './Detail.style';
interface Props {
  creatorImg: string;
  creatorName: string;
  title: string;
  description: string;
  cookingTime: string;
  people: string;
  isLike: boolean;
  onUpdateLikeState: () => void;
}
const Detail: FC<Props> = ({
  creatorImg,
  creatorName,
  title,
  description,
  cookingTime,
  people,
  isLike,
  onUpdateLikeState
}: Props) => {
  const {
    width
  } = useWindowSize();
  return <DetailWrapper>
            <CreatorProfile imageUrl={creatorImg} name={creatorName} size={width > breakpoint.md ? 'large' : 'small'} />
            <Title>{title}</Title>
            <Desceiption>{description}</Desceiption>
            <Wrapper>
                <CookingTimeAndPeople cookingTime={cookingTime} people={people} />
                <ButtonWrapper>
                    <HeartButton isLike={isLike} onUpdateLikeState={onUpdateLikeState} />
                    <ShareButton caption={title} path={window.location.pathname} />
                </ButtonWrapper>
            </Wrapper>
        </DetailWrapper>;
};
export default Detail;